// Domain Types - Common types and interfaces used across the domain layer

/**
 * Invoice configuration for domain services
 */
export interface InvoiceConfig {
  readonly prefix?: string | undefined; // Optional prefix, undefined means no prefix
}

/**
 * Sanitizes invoice prefix to ensure it contains only alphanumeric characters and hyphens,
 * and is no longer than 10 characters
 */
export const sanitizeInvoicePrefix = (prefix: string): string => {
  // Remove any characters that aren't alphanumeric or hyphens
  const sanitized = prefix.replace(/[^a-zA-Z0-9-]/g, "");

  // Truncate to maximum 10 characters
  return sanitized.substring(0, 10);
};
